import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { genElZirvuImage } from "../../../../components/utils/EditorDialogElementGenerator";

// genElZirvuImage is a component (it has hooks), so it is rendered as one
const ZirvuImage = genElZirvuImage;

// The dialog to edit the note and the photo of a checklist row.
// folderName: folder of the file manager the photo goes to (see getFotoFolderName)
const EditorNoteDialog = ({
  showEditDeskripsiTambahanDialog,
  setShowEditDeskripsiTambahanDialog,
  popoverPengecekanData,
  setPopoverPengecekanData,
  handleOnConfirmEditNote,
  folderName,
}) => {
  return (
    <Dialog
      header="Tambah Note Tambahan"
      visible={showEditDeskripsiTambahanDialog}
      style={{ width: "30rem" }}
      onHide={() => {
        setShowEditDeskripsiTambahanDialog(false);
      }}
      footer={
        <React.Fragment>
          <Button
            label="Tutup"
            icon="pi pi-times"
            outlined
            onClick={() => {
              setShowEditDeskripsiTambahanDialog(false);
            }}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            onClick={() => {
              handleOnConfirmEditNote(
                popoverPengecekanData,
                popoverPengecekanData.note
              );
            }}
          />
        </React.Fragment>
      }
    >
      <div className="col-start-start pt-2 w-full gap-2">
        <div className="col-start-start w-full gap-1">
          <label htmlFor="note" className="font-bold text-sm text-slate-500">
            Note
          </label>
          <InputTextarea
            id="note"
            className="w-full"
            rows={3}
            autoResize
            value={popoverPengecekanData.note ?? ""}
            onChange={(e) =>
              setPopoverPengecekanData({
                ...popoverPengecekanData,
                note: e.target.value,
              })
            }
          />
        </div>
        <ZirvuImage
          field="gambar"
          name="Gambar"
          folderName={folderName}
          data={{ gambar: popoverPengecekanData.gambar ?? "" }}
          setData={(newData) => {
            const current = { gambar: popoverPengecekanData.gambar ?? "" };
            const resolved =
              typeof newData === "function" ? newData(current) : newData;
            setPopoverPengecekanData({
              ...popoverPengecekanData,
              gambar: resolved.gambar ?? "",
            });
          }}
          error={{}}
        />
      </div>
    </Dialog>
  );
};

export default EditorNoteDialog;
